import { render, staticRenderFns } from "./ApkMangement.vue?vue&type=template&id=270974c9&scoped=true&"
import script from "./ApkMangement.vue?vue&type=script&lang=js&"
export * from "./ApkMangement.vue?vue&type=script&lang=js&"
import style0 from "./ApkMangement.vue?vue&type=style&index=0&id=270974c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270974c9",
  null
  
)

export default component.exports